<template>
  <v-form class='createPqrAwsForm' v-model='valid' ref='createPqrAwsForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <div class="logo_box text-center">
            <v-img :src="$getCompanyData().url"></v-img>
          </div>
        </v-col>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <h4>Procedure Qualification Record</h4>
        </v-col>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <v-row class="d-none">
            <v-col cols='12' md='6' sm='6' xs='12'>
              <module-prefix :module="'pqr_aws'" :prefix.sync="pqrAws.prefix" :no.sync="pqrAws.no" v-if="!pqrAws.id"/>
              <v-text-field
                v-model="pqrAws.prefix"
                label='Prefix'
                placeholder='Prefix'
                v-if="pqrAws.id"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols='12' md='6' sm='6' xs='12'>
              <v-text-field
              v-model='pqrAws.no'
              :error-messages='error.no'
              label='No'
              placeholder='No'
              readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-text-field
            label='Procedure No'
            placeholder='Procedure No'
            :value="bindPqrAwsNo"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <v-text-field
            v-model='pqrAws.company_name'
            :error-messages='error.company_name'
            label='Company Name'
            placeholder='Company Name'
          ></v-text-field>
          <v-textarea
            v-model="pqrAws.company_address"
            :error-messages='error.company_address'
            label="Company Address"
            placeholder="Company Address"
            rows="3"
          ></v-textarea>
        </v-col>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <searchable-select :value.sync="pqrAws.referred_standard_id" :options="{ url: 'referred_standard', label: 'Refrerred Standard'}" :errorMessage="error.referred_standard_id" :selectedData="{id: pqrAws.referred_standard_id, text: pqrAws.referred_standard_name}"/>
          <!-- <searchable-select :value.sync="pqrAws.pqr_id" :options="{ url: 'welding_procedure', label: 'Supporting Pqrs', data: {'type' : 'pqr'} }" :errorMessage="error.pqr_id" :selectedData="{id: pqrAws.pqr_id, text: pqrAws.pqr_name}"/> -->
          <searchable-select :value.sync="pqrAws.wptwpr_id" :options="{ url: 'welding_process', label: 'Welding Process', multiple: true, returnType: 'object' }" :errorMessage="error.wptwpr_id" :selectedData="pqrAws.wptwpr_id" :addNew="{right: 'edit_welding_process', module: 'weldingProcess', title: 'Create Welding Process'}"/>
        </v-col>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <v-text-field
            v-model="pqrAws.rev_date"
            :error-messages="error.rev_date"
            type="date"
            label="Rev Date"
          ></v-text-field>
          <v-text-field
            v-model='pqrAws.rev_no'
            :error-messages='error.rev_no'
            label='Rev No'
            placeholder='Rev No'
          ></v-text-field>
          <searchable-select :value.sync="pqrAws.wptwt_id" :options="{ url: 'welding_type', label: 'Welding Type', multiple: true, returnType: 'object' }" :errorMessage="error.wptwt_id" :selectedData="pqrAws.wptwt_id" :addNew="{right: 'edit_welding_type', module: 'weldingType', title: 'Create Welding Type'}"/>
          <!-- <searchable-select :value.sync="pqrAws.qualification_method_id" :options="{ url: 'qualification_method', label: 'Qualification Method'}" :errorMessage="error.qualification_method_id" :selectedData="{id: pqrAws.qualification_method_id, text: pqrAws.qualification_method_name}"/> -->
        </v-col>
      </v-row>
      <hr />
      <h4 class="text-center">Joint Design</h4>
      <v-row>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='pqrAws.joint_design'
            :error-messages='error.joint_design'
            label='Joint Design'
            placeholder='Joint Design'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
         <v-checkbox
           v-model="pqrAws.joint_backing"
           label="Joint Backing"
         ></v-checkbox>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='pqrAws.joint_backing_material'
            :error-messages='error.joint_backing_material'
            label='Backing Material'
            placeholder='Backing Material'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
         <v-checkbox
           v-model="pqrAws.back_gouging"
           label="Back Gouging"
         ></v-checkbox>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='pqrAws.back_gouging_method'
            :error-messages='error.back_gouging_method'
            label='Back Gouging Method'
            placeholder='Back Gouging Method'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <searchable-select :value.sync="pqrAws.joint_type_id" :options="{ url: 'joint_type', label: 'Joint Type'}" :errorMessage="error.joint_type_id" :selectedData="{id: pqrAws.joint_type_id, text: pqrAws.joint_type_name}" :addNew="{right: 'edit_joint_type', module: 'jointType', title: 'Create Joint Type'}"/>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='pqrAws.root_spacing'
            :error-messages='error.root_spacing'
            label='Root Spacing'
            placeholder='Root Spacing'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='pqrAws.root_face'
            :error-messages='error.root_face'
            label='Root Face'
            placeholder='Root Face'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='pqrAws.groove_angle'
            :error-messages='error.groove_angle'
            label='Groove Angle'
            placeholder='Groove Angle'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='pqrAws.radius'
            :error-messages='error.radius'
            label='Radius'
            placeholder='Radius'
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" xs="12">
          <p>Joint Drawings</p>
          <input type="file" class="d-none" ref="file_input_join_drawing" @change="fileChangeEvent" @click="resetImageUploader" multiple>
          <div class="upload_container">
            <v-row v-for="(image, i) in images" :key="i">
              <v-col cols='12' md='4' sm='12' xs='12'>
                <div class="position-relative">
                  <v-img
                    :src="`${image.url}`"
                  ></v-img>
                  <div class="wl-close-icon text-center" @click="removeImage(i)">
                    <v-icon size="16" color="white">mdi-delete</v-icon>
                  </div>
                </div>
              </v-col>
              <v-col cols='12' md='8' sm='12' xs='12'>
                <v-row>
                  <v-col cols='12' md='2' sm='6' xs='12'>
                    <v-text-field
                    v-model='image.param_a'
                    label='A'
                    placeholder='A'
                    ></v-text-field>
                  </v-col>
                  <v-col cols='12' md='2' sm='6' xs='12'>
                    <v-text-field
                    v-model='image.param_b'
                    label='B'
                    placeholder='B'
                    ></v-text-field>
                  </v-col>
                  <v-col cols='12' md='2' sm='6' xs='12'>
                    <v-text-field
                    v-model='image.param_c'
                    label='C'
                    placeholder='C'
                    ></v-text-field>
                  </v-col>
                  <v-col cols='12' md='2' sm='6' xs='12'>
                    <v-text-field
                    v-model='image.param_d'
                    label='D'
                    placeholder='D'
                    ></v-text-field>
                  </v-col>
                  <v-col cols='12' md='2' sm='6' xs='12'>
                    <v-text-field
                    v-model='image.param_e'
                    label='E'
                    placeholder='E'
                    ></v-text-field>
                  </v-col>
                  <v-col cols='12' md='2' sm='6' xs='12'>
                    <v-text-field
                    v-model='image.param_f'
                    label='F'
                    placeholder='F'
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <div class="text-right">
            <v-btn color="primary" small class="ma-1" @click="loadGallery = true">Select Image</v-btn>
            <v-btn color="primary" small class="ma-1" @click="uploadImage">Upload Image</v-btn>
          </div>
        </v-col>
      </v-row>
      <hr />
      <h4 class="text-center">Base Metals</h4>
      <v-row v-if="error.base_metal ? error.base_metal[0] : false">
        <v-col cols="12" md="12" sm="12" xs="12" class="py-0">
          <span class="red--text">{{ error.base_metal ? error.base_metal[0] : '' }}</span>
        </v-col>
      </v-row>
      <v-row v-for="(item, index) in pqrAws.base_metal" :key="index" class="pt-5">
        <v-col cols="12" lg="11" md="11" sm="12" xs="12" class="py-0">
          <v-row>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
              <v-text-field
                label="Base Metal"
                placeholder="Base Metal"
                v-model="pqrAws.base_metal[index].base_metal"
                :error-messages="error[`base_metal.${index}.base_metal`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
              <v-text-field
                label="Name / Grade"
                placeholder="Name / Grade"
                v-model="pqrAws.base_metal[index].grade"
                :error-messages="error[`base_metal.${index}.grade`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Material Specification"
                placeholder="Material Specification"
                v-model="pqrAws.base_metal[index].material_specification"
                :error-messages="error[`base_metal.${index}.material_specification`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="P No"
                placeholder="P No"
                v-model="pqrAws.base_metal[index].p_no"
                :error-messages="error[`base_metal.${index}.p_no`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Group No"
                placeholder="Group No"
                v-model="pqrAws.base_metal[index].group_no"
                :error-messages="error[`base_metal.${index}.group_no`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Thickness"
                placeholder="Thickness"
                v-model="pqrAws.base_metal[index].thickness"
                :error-messages="error[`base_metal.${index}.thickness`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Groove Thickness Range"
                placeholder="Groove Thickness Range"
                v-model="pqrAws.base_metal[index].groove_thickness_range"
                :error-messages="error[`base_metal.${index}.groove_thickness_range`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Fillet Thickness Range"
                placeholder="Fillet Thickness Range"
                v-model="pqrAws.base_metal[index].fillet_thickness_range"
                :error-messages="error[`base_metal.${index}.fillet_thickness_range`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Pipe Diameter Range"
                placeholder="Pipe Diameter Range"
                v-model="pqrAws.base_metal[index].pipe_diameter_range"
                :error-messages="error[`base_metal.${index}.pipe_diameter_range`]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="1" md="1" sm="12" xs="12" align-self="center" class="pt-0">
          <v-row>
            <v-col cols="12" class="text-center">
              <v-icon @click="removeBaseMetal(index)" v-if="!$vuetify.breakpoint.mdAndDown">mdi-delete-circle</v-icon>
              <v-btn @click="removeBaseMetal(index)" small block v-else>Delete</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="pqrAws.base_metal.length < 2">
        <v-col cols="12" md="12" sm="12" xs="12" class="pb-5">
          <v-btn color="primary" class="mr-2" @click="addBaseMetal" small :block="$vuetify.breakpoint.mdAndDown">Add New</v-btn>
        </v-col>
      </v-row>
      <hr />
      <v-row>
        <v-col cols="12" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Filler Metals</h4>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='pqrAws.aws_classification'
              :error-messages='error.aws_classification'
              label='AWS Classification'
              placeholder='AWS Classification'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='pqrAws.filler_metal_diameter'
              :error-messages='error.filler_metal_diameter'
              label='Filler Metal Diameter'
              placeholder='Filler Metal Diameter'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='pqrAws.manufacturer_trade_name'
              :error-messages='error.manufacturer_trade_name'
              label='Manufacturer Trade Name'
              placeholder='Manufacturer Trade Name'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='pqrAws.filler_metal_other'
              :error-messages='error.filler_metal_other'
              label='Other'
              placeholder='Other'
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Shielding</h4>
          <v-row>
            <v-col cols='12' md='4' sm='4' xs='12' class='radio-with-lable'>
              <label class="c-radio-label">Flux</label>
              <v-radio-group v-model="pqrAws.flux" row>
                <v-radio label="Yes" :value="1" class="mt-0"></v-radio>
                <v-radio label="No" :value="0" class="mt-0"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="8" sm="8" xs="12">
              <v-text-field
              v-model='pqrAws.electrode_flux'
              :error-messages='error.electrode_flux'
              label='Electrode Flux (Class)'
              placeholder='Electrode Flux (Class)'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='pqrAws.composition_per'
              :error-messages='error.composition_per'
              label='Gas + Composition %'
              placeholder='Gas + Composition %'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='pqrAws.flow_rate'
              :error-messages='error.flow_rate'
              label='Flow Rate'
              placeholder='Flow Rate'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='pqrAws.nozzle_size'
              :error-messages='error.nozzle_size'
              label='Nozzle Size'
              placeholder='Nozzle Size'
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <hr />
      <v-row class="mt-2">
        <v-col cols="12" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Positions</h4>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='pqrAws.position_of_groove'
              :error-messages='error.position_of_groove'
              label='Positions Of Groove'
              placeholder='Positions Of Groove'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='pqrAws.position_of_fillet'
              :error-messages='error.position_of_fillet'
              label='Positions Of Fillet'
              placeholder='Positions Of Fillet'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='pqrAws.welding_progression'
              :error-messages='error.welding_progression'
              label='Welding Progression'
              placeholder='Welding Progression'
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Electrical Charecteristics</h4>
          <v-row>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
              v-model='pqrAws.tungsten_type'
              :error-messages='error.tungsten_type'
              label='Tungsten Type'
              placeholder='Tungsten Type'
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
              v-model='pqrAws.tungsten_size'
              :error-messages='error.tungsten_size'
              label='Tungsten Size'
              placeholder='Tungsten Size'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
              v-model='pqrAws.torch_angle'
              :error-messages='error.torch_angle'
              label='Torch Angle'
              placeholder='Torch Angle'
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
              v-model='pqrAws.current'
              :error-messages='error.current'
              label='Current'
              placeholder='Current'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='pqrAws.mode_of_metal_transfer'
              :error-messages='error.mode_of_metal_transfer'
              label='Model Of Metal Transfer(GMAW)'
              placeholder='Model Of Metal Transfer(GMAW)'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-textarea
              v-model="pqrAws.electrical_char_remark"
              :error-messages='error.electrical_char_remark'
              label="Remarks"
              placeholder="Remarks"
              rows="1"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <hr />
      <v-row class="mt-2">
        <v-col cols="12" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Preheat</h4>
          <v-row >
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='pqrAws.preheat_temperature_min'
                :error-messages='error.preheat_temperature_min'
                label='Preheat Temperature Min'
                placeholder='Preheat Temperature Min'
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='pqrAws.preheat_temperature_max'
                :error-messages='error.preheat_temperature_max'
                label='Preheat Temperature Max'
                placeholder='Preheat Temperature Max'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row >
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='pqrAws.interpass_temperature_min'
                :error-messages='error.interpass_temperature_min'
                label='Interpass Temperature Min'
                placeholder='Interpass Temperature Min'
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='pqrAws.interpass_temperature_max'
                :error-messages='error.interpass_temperature_max'
                label='Interpass Temperature Max'
                placeholder='Interpass Temperature Max'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-textarea
                v-model="pqrAws.preheat_maintenance"
                :error-messages='error.preheat_maintenance'
                label="Maintenance"
                placeholder="Maintenance"
                rows="1"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Post Heat Treatment</h4>
          <v-row >
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='pqrAws.postheat_temperature_min'
                :error-messages='error.postheat_temperature_min'
                label='Postheat Temperature Min'
                placeholder='Postheat Temperature Min'
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='pqrAws.postheat_temperature_max'
                :error-messages='error.postheat_temperature_max'
                label='Postheat Temperature Max'
                placeholder='Postheat Temperature Max'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row >
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='pqrAws.time_min'
                :error-messages='error.time_min'
                label='Time Min'
                placeholder='Time Min'
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='pqrAws.time_max'
                :error-messages='error.time_max'
                label='Time Max'
                placeholder='Time Max'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-textarea
                v-model="pqrAws.postheat_remark"
                :error-messages='error.postheat_remark'
                label="Remarks"
                placeholder="Remarks"
                rows="1"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <hr />
      <h4 class="text-center mt-2">Technique</h4>
      <v-row class="mt-2">
        <v-col cols="12" md="6" sm="12" xs="12">
          <v-text-field
            v-model='pqrAws.oscillation'
            :error-messages='error.oscillation'
            label='Oscillation Frequency'
            placeholder='Oscillation Frequency'
          ></v-text-field>
          <v-text-field
            v-model='pqrAws.weave_bead'
            :error-messages='error.weave_bead'
            label='String or Weave Bead'
            placeholder='String or Weave Bead'
          ></v-text-field>
          <v-text-field
            v-model='pqrAws.electrode_spacing'
            :error-messages='error.electrode_spacing'
            label='Electrode Spacing'
            placeholder='Electrode Spacing'
          ></v-text-field>
          <v-row>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='pqrAws.cleaning'
                :error-messages='error.cleaning'
                label='Interpass / Final Cleaning'
                placeholder='Interpass / Final Cleaning'
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='pqrAws.peening'
                :error-messages='error.peening'
                label='Peening'
                placeholder='Peening'
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" sm="12" xs="12">
          <v-row>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='pqrAws.weave_width'
                :error-messages='error.weave_width'
                label='Weave Width'
                placeholder='Weave Width'
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='pqrAws.dwell_time'
                :error-messages='error.dwell_time'
                label='Dwell Time'
                placeholder='Dwell Time'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-text-field
            v-model='pqrAws.electrode'
            :error-messages='error.electrode'
            label='Number Of Electrodes'
            placeholder='Number Of Electrodes'
          ></v-text-field>
          <v-autocomplete
            v-model="pqrAws.pass_perside"
            item-value="id"
            :items="[ {id: 'single', text: 'Single'}, {id: 'multiple', text: 'Multiple'}]"
            :error-messages='error.pass_perside'
            label='Multiple Or Single Pass (perside)'
            placeholder='Multiple Or Single Pass (perside)'
          ></v-autocomplete>
          <v-text-field
            v-model='pqrAws.contact_tube_work_distance'
            :error-messages='error.contact_tube_work_distance'
            label='Contact Tube Work Distance'
            placeholder='Contact Tube Work Distance'
          ></v-text-field>
        </v-col>
      </v-row>
      <hr />
      <h4 class="text-center mt-2">Welding Parameters</h4>
      <v-row v-if="error.welding_parameter ? error.welding_parameter[0] : false">
        <v-col cols="12" md="12" sm="12" xs="12" class="py-0">
          <span class="red--text">{{ error.welding_parameter ? error.welding_parameter[0] : '' }}</span>
        </v-col>
      </v-row>
      <v-row v-for="(item, ind) in pqrAws.welding_parameter" :key="`welding_parameter_${ind}`" class="pt-5">
          <v-col cols="12" lg="11" md="11" sm="12" xs="12" class="py-0">
            <v-row>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
                <searchable-select :value.sync="pqrAws.welding_parameter[ind].welding_process_id" :options="{ url: 'welding_process', label: 'Welding Process' }" :errorMessage="error[`welding_parameter.${ind}.welding_process_id`]" :selectedData="bindWpmWeldingProcess(ind)" :key="ind"/>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
                <v-text-field
                label="Weld Layer"
                placeholder="Weld Layer"
                v-model="pqrAws.welding_parameter[ind].weld_layer"
                :error-messages="error[`welding_parameter.${ind}.weld_layer`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Filler Class"
                placeholder="Filler Class"
                v-model="pqrAws.welding_parameter[ind].filler_class"
                :error-messages="error[`welding_parameter.${ind}.filler_class`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Filler Size"
                placeholder="Filler Size"
                v-model="pqrAws.welding_parameter[ind].filler_size"
                :error-messages="error[`welding_parameter.${ind}.filler_size`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
                <searchable-select :value.sync="pqrAws.welding_parameter[ind].polarity_id" :options="{ url: 'polarity', label: 'Polarity' }" :errorMessage="error[`welding_parameter.${ind}.polarity_id`]" :selectedData="bindWpmPolarity(ind)" :key="ind" :disabled="pqrAws.welding_parameter[ind].id !== undefined ? true : false"/>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Current(A)"
                placeholder="Min Current(A)"
                v-model="pqrAws.welding_parameter[ind].min_current"
                :error-messages="error[`welding_parameter.${ind}.min_current`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Current(A)"
                placeholder="Max Current(A)"
                v-model="pqrAws.welding_parameter[ind].max_current"
                :error-messages="error[`welding_parameter.${ind}.max_current`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Voltage(V)"
                placeholder="Min Voltage(V)"
                v-model="pqrAws.welding_parameter[ind].min_voltage"
                :error-messages="error[`welding_parameter.${ind}.min_voltage`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Voltage(V)"
                placeholder="Max Voltage(V)"
                v-model="pqrAws.welding_parameter[ind].max_voltage"
                :error-messages="error[`welding_parameter.${ind}.max_voltage`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Travel Speed"
                placeholder="Min Travel Speed"
                v-model="pqrAws.welding_parameter[ind].min_travel_speed"
                :error-messages="error[`welding_parameter.${ind}.min_travel_speed`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Travel Speed"
                placeholder="Max Travel Speed"
                v-model="pqrAws.welding_parameter[ind].max_travel_speed"
                :error-messages="error[`welding_parameter.${ind}.max_travel_speed`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Feed Speed"
                placeholder="Min Feed Speed"
                v-model="pqrAws.welding_parameter[ind].min_feed_speed"
                :error-messages="error[`welding_parameter.${ind}.min_feed_speed`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Feed Speed"
                placeholder="Max Feed Speed"
                v-model="pqrAws.welding_parameter[ind].max_feed_speed"
                :error-messages="error[`welding_parameter.${ind}.max_feed_speed`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Flow Rate"
                placeholder="Min Flow Rate"
                v-model="pqrAws.welding_parameter[ind].min_flowrate"
                :error-messages="error[`welding_parameter.${ind}.min_flowrate`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Flow Rate"
                placeholder="Max Flow Rate"
                v-model="pqrAws.welding_parameter[ind].max_flowrate"
                :error-messages="error[`welding_parameter.${ind}.max_flowrate`]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" lg="1" md="1" sm="12" xs="12" align-self="center" class="pt-0">
            <v-row>
              <v-col cols="12" class="text-center">
                <v-icon @click="removeWeldingParameter(ind)" v-if="!$vuetify.breakpoint.mdAndDown">mdi-delete-circle</v-icon>
                <v-btn @click="removeWeldingParameter(ind)" small block v-else>Delete</v-btn>
              </v-col>
            </v-row>
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" class="pb-5">
          <v-btn color="primary" class="mr-2" @click="addWeldingParameter" small :block="$vuetify.breakpoint.mdAndDown">Add New</v-btn>
        </v-col>
      </v-row>
      <hr />
      <v-row class="mt-2">
        <v-col cols="12" md="6" sm="12" xs="12">
          <v-text-field
            v-model='pqrAws.prepared_by'
            :error-messages='error.prepared_by'
            label='Prepared By'
            placeholder='Prepared By'
          ></v-text-field>
          <v-textarea
            v-model="pqrAws.prepared_by_sign"
            :error-messages='error.prepared_by_sign'
            label="Prepared By Signature"
            placeholder="Prepared By Signature"
            rows="2"
          ></v-textarea>
          <v-text-field
            v-model="pqrAws.prepared_date"
            :error-messages="error.prepared_date"
            type="date"
            label="Date"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" sm="12" xs="12">
          <v-text-field
            v-model='pqrAws.approved_by'
            :error-messages='error.approved_by'
            label='Approved By'
            placeholder='Approved By'
          ></v-text-field>
          <v-textarea
            v-model="pqrAws.approved_by_sign"
            :error-messages='error.approved_by_sign'
            label="Approved By Signature"
            placeholder="Approved By Signature"
            rows="2"
          ></v-textarea>
          <v-text-field
            v-model="pqrAws.approved_date"
            :error-messages="error.approved_date"
            type="date"
            label="Date"
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='4' sm='6' xs='12' >
          <label class="c-radio-label">Status</label>
          <v-radio-group v-model="pqrAws.status" row class='radio-with-lable'>
            <v-radio label="Active" :value="0" class="mt-0"></v-radio>
            <v-radio label="Inactive" :value="1" class="mt-0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-container>
    <v-footer fixed>
      <v-col class="text-right">
        <v-btn color="primary" class="mr-2" @click="submit" small>{{ edit_id ? 'Update' : 'Add' }}</v-btn>
        <v-btn color="default" @click="reset" small>Reset</v-btn>
      </v-col>
    </v-footer>
    <ImageGallery v-if="loadGallery" :isOpen="loadGallery" @closeGallery="loadGallery=false;" @selectedImage="getSelectedImage"></ImageGallery>
  </v-form>
</template>

<script>
import ImageGallery from '../../components/imageGallery.vue'
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  components: {
    ImageGallery,
  },
  computed: {
    bindPqrAwsNo () {
      return this.pqrAws.prefix + ((this.pqrAws.no ? this.pqrAws.no : '').toString().padStart(4, '0'))
    }
  },
  created () {
    const companyData = this.$getCompanyData()
    this.pqrAws.company_name = companyData.name
    this.pqrAws.company_address = companyData.address
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.edit_id = id
      const url = 'getWeldingProcedureById/'
      this.getDataById(url, id)
    } else {
      this.edit_id = undefined
      const storageData = localStorage.getItem('clone_data')
      if (storageData) {
        const _storageData = JSON.parse(storageData)
        const url = 'getWeldingProcedureCloneById/'
        this.getDataById(url, _storageData.module_id)
      }
      localStorage.removeItem('clone_data')
    }
    this.pqrAws.base_metal.push(
      { base_metal: '', grade: '', material_specification: '', p_no: '', group_no: '', thickness: '', groove_thickness_range: '', fillet_thickness_range: '', pipe_diameter_range: '' },
    )
    this.pqrAws.welding_parameter.push(
      { welding_process_id: {}, weld_layer: '', filler_class: '', filler_size: '', polarity_id: {}, min_current: '', max_current: '', min_voltage: '', max_voltage: '', min_travel_speed: '', max_travel_speed: '', min_feed_speed: '', max_feed_speed: '', min_flowrate: '', max_flowrate: '' }
    )
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      pqrAws: { prefix: '', no: '', status: 0, flux: 1, rev_no: 0, rev_date: new Date().toISOString().substr(0, 10), base_metal: [], welding_parameter: [] },
      error: {},
      images: [],
      deletedImages: [],
      loadGallery: false
    }
  },
  methods: {
    getDataById (url, id) {
      this.$axios.post(url + id).then((res) => {
        const data = res.data.welding_procedure
        data.wptwpr_id = res.data.wptwpr
        data.wptwt_id = res.data.wptwt
        data.base_metal = res.data.base_metal
        data.filler_metal = res.data.filler_metal
        data.welding_parameter = res.data.welding_parameter
        this.pqrAws = data
        this.images = res.data.welding_procedure_drawing
        setTimeout(() => {
          /* this.pqrAws.filler_metal.push({ welding_process_id: {}, f_no: '', a_no: '', spec_no: '', aws_class: '', filler_size: '', deposited_weld_metal_thickness: '', groove: '', fillet: '', electrode_flux_class: '', remarks: '' })
          const l = this.pqrAws.filler_metal.length
          this.pqrAws.filler_metal.splice((l - 1), 1) */
          this.pqrAws.welding_parameter.push({ welding_process_id: {}, weld_layer: '', filler_class: '', filler_size: '', polarity_id: {}, min_current: '', max_current: '', min_voltage: '', max_voltage: '', min_travel_speed: '', max_travel_speed: '', min_feed_speed: '', max_feed_speed: '', min_flowrate: '', max_flowrate: '' })
          const l1 = this.pqrAws.welding_parameter.length
          this.pqrAws.welding_parameter.splice((l1 - 1), 1)
        }, 1000)
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    },
    submit () {
      if (Object.keys(this.error).length > 0) {
        this.error = {}
        this.valid = true
      }
      if (this.valid) {
        const route = this.edit_id ? 'saveWeldingProcedure/' + this.edit_id : 'saveWeldingProcedure'
        this.pqrAws.type = 'pqr_aws'
        this.pqrAws.images = this.images
        this.pqrAws.deletedImages = this.deletedImages
        this.$axios.post(route, this.pqrAws).then((res) => {
          this.$eventBus.$emit('$globalSnackbar', 'success', res.data.success_description)
          if (this.edit_id) {
            this.$router.push('/weldingProcedure')
          } else {
            const resData = res.data.data
            this.reset(resData)
          }
        }).catch((err) => {
          if (err.response.status === 422) {
            this.error = err.response.data.error_data
          } else {
            this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
          }
        })
      } else {
        this.$refs.createPqrAwsForm.validate()
      }
    },
    reset (resData = {}) {
      // when form reset set old prefix and no for continute the sequence
      const oldPrefix = resData.prefix
      const oldSrNo = resData.no
      this.$refs.createPqrAwsForm.reset()
      setTimeout(() => {
        this.pqrAws = { prefix: oldPrefix, no: oldSrNo, status: 0, flux: 1, rev_no: 0, rev_date: new Date().toISOString().substr(0, 10), base_metal: [], welding_parameter: [] }
        this.error = {}
        this.images = []
        this.deletedImages = []
        // this.$refs.firstInput.focus()
      }, 300)
    },
    /* addFillerMetal () {
      this.pqrAws.filler_metal.push({ welding_process_id: {}, f_no: '', a_no: '', spec_no: '', aws_class: '', filler_size: '', deposited_weld_metal_thickness: '', groove: '', fillet: '', electrode_flux_class: '', remarks: '' })
    },
    removeFillerMetal (index) {
      this.pqrAws.filler_metal.splice(index, 1)
    },
    bindWeldingProcess (ind) {
      const bindFiller = {}
      bindFiller.id = this.pqrAws.filler_metal[ind].wps_id
      bindFiller.text = this.pqrAws.filler_metal[ind].wps_text
      return bindFiller
    }, */
    addBaseMetal () {
      this.pqrAws.base_metal.push({ base_metal: '', grade: '', material_specification: '', p_no: '', group_no: '', thickness: '', groove_thickness_range: '', fillet_thickness_range: '', pipe_diameter_range: '' })
    },
    removeBaseMetal (index) {
      this.pqrAws.base_metal.splice(index, 1)
    },
    addWeldingParameter () {
      this.pqrAws.welding_parameter.push({ welding_process_id: {}, weld_layer: '', filler_class: '', filler_size: '', polarity_id: {}, min_current: '', max_current: '', min_voltage: '', max_voltage: '', min_travel_speed: '', max_travel_speed: '', min_feed_speed: '', max_feed_speed: '' })
    },
    removeWeldingParameter (ind) {
      this.pqrAws.welding_parameter.splice(ind, 1)
    },
    bindWpmWeldingProcess (ind) {
      const wpmWeldingProcess = {}
      wpmWeldingProcess.id = this.pqrAws.welding_parameter[ind].wpm_wps_id
      wpmWeldingProcess.text = this.pqrAws.welding_parameter[ind].wpm_wps_text
      return wpmWeldingProcess
    },
    bindWpmPolarity (ind) {
      const wpmPolarity = {}
      wpmPolarity.id = this.pqrAws.welding_parameter[ind].wpm_plr_id
      wpmPolarity.text = this.pqrAws.welding_parameter[ind].wpm_plr_text
      return wpmPolarity
    },
    uploadImage () {
      this.$refs.file_input_join_drawing.click()
    },
    resetImageUploader () {
      this.$refs.file_input_join_drawing.value = ''
    },
    fileChangeEvent () {
      if (this.$refs.file_input_join_drawing.files.length) {
        const formData = new FormData()
        formData.append('access_token', localStorage.getItem(process.env.VUE_APP_LSACCESSTOKENKEY))
        formData.append('request_from', 'clientApp')
        for (let i = 0; i < this.$refs.file_input_join_drawing.files.length; i++) {
          const file = this.$refs.file_input_join_drawing.files[i]
          formData.append('files[' + i + ']', file)
        }
        this.$axios.post('upload', formData, { removeCommonParams: true, requestForSearchable: true }).then((res) => {
          this.images = [...this.images, ...res.data.files]
        }).catch((err) => {
          console.log(err.response)
        })
      }
    },
    removeImage (i) {
      const image = this.images[i]
      const data = {}
      data.is_new_uploaded = !!image.is_new_uploaded
      data.is_from_gallery = !!image.is_from_gallery
      data.filename = image.name
      data.module = 'welding_procedure'
      this.images.splice(i, 1)
      if (!data.is_new_uploaded && !data.is_from_gallery) {
        const temp = [image]
        this.deletedImages = [...this.deletedImages, ...temp]
        return
      }
      this.$axios.post('deleteUploadImage', data, { mainLoader: false }).then((res) => {})
    },
    getSelectedImage (value) {
      this.images = [...this.images, ...value]
    }
  },
}
</script>

<style>
.createPqrAwsForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.createPqrAwsForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.logo_box {
  border: 1px dotted #ccc;
  max-width: 200px;
}
.upload_container {
  height: 300px;
  width: 100%;
  position : relative;
}
</style>
